import React from 'react'

const Image = ({ src }) => {
  const styles = {
    backgroundImage: `url("${src}")`
  }

  return (
    <div className='w-full md:w-1/2 md:pr-4 pb-4'>
      <div className='h-64 bg-cover bg-center' style={styles} />
    </div>
  )
}

export default Image
